var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6626 9.64706L20.3762 6.33797C20.159 6.12151 19.8651 6 19.5588 6C19.2524 6 18.9585 6.12151 18.7413 6.33797L7.09038 17.9927L6.02662 22.5918C5.98992 22.7599 5.99118 22.9341 6.0303 23.1017C6.06942 23.2692 6.14542 23.4259 6.25273 23.5603C6.36005 23.6947 6.49598 23.8034 6.65059 23.8784C6.80519 23.9534 6.97458 23.9929 7.14637 23.9939C7.22641 24.002 7.30707 24.002 7.38711 23.9939L12.0285 22.9283L23.6626 11.2848C23.8787 11.0672 24 10.7728 24 10.4659C24 10.159 23.8787 9.86461 23.6626 9.64706ZM11.4686 21.9187L7.11837 22.8329L8.10935 18.5592L16.8266 9.86019L20.1858 13.2254L11.4686 21.9187ZM20.936 12.4121L17.5768 9.04694L19.5252 7.10635L22.8284 10.4715L20.936 12.4121Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit_circle.35a4b30522b44841e916347c2221c736.svg";
export { ForwardRef as ReactComponent };